import getViewportPosition from './getViewportPosition';
import { easeInOutQuint } from './easing';
var move = function move(scrollTop) {
  global.scrollTo(0, scrollTop);
};
export default (function (to) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var start = getViewportPosition();
  var change = to - start;
  var startTimestamp = new Date();
  var animateScroll = function animateScroll() {
    var now = new Date();
    var currentTime = now - startTimestamp;
    var val = easeInOutQuint(currentTime, start, change, duration);
    move(val);
    if (currentTime < duration) {
      requestAnimationFrame(animateScroll);
    } else {
      move(to);
      callback();
    }
  };
  animateScroll();
});